<template>
  <div>
    <div class="setting" style="background:#fff;height:100%;">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="$router.go(-1)"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>更换背景音乐</h4></div>
      </div>
      <audio
        v-if="hallInfo.musicBackground == 1"
        ref="audio1"
        src="../../../assets/jnt/music/1.mp3"
        loop=""
        autoplay=""
      ></audio>
      <audio
        v-if="hallInfo.musicBackground == 2"
        ref="audio1"
        src="../../../assets/jnt/music/2.mp3"
        loop=""
        autoplay=""
      ></audio>
      <audio
        v-if="hallInfo.musicBackground == 3"
        ref="audio1"
        src="../../../assets/jnt/music/3.mp3"
        loop=""
        autoplay=""
      ></audio>
      <audio
        v-if="hallInfo.musicBackground == 4"
        ref="audio1"
        src="../../../assets/jnt/music/4.mp3"
        loop=""
        autoplay=""
      ></audio>
      <audio
        v-if="hallInfo.musicBackground == 5"
        ref="audio1"
        src="../../../assets/jnt/music/5.mp3"
        loop=""
        autoplay=""
      ></audio>
      <div>
        <div class="msg_list-row">
          <span
            ><li class="row-music-item">
              <div class="music-item-fr f-bd f-bd-btm">
                <div class="music-item-name"><div class="f-thide name">记忆走廊</div></div>
                <span style="display: contents;">
                  <span
                    v-if="hallInfo.musicBackground == 1 && isPlaying"
                    @click="stop(1)"
                    class="music-icon music-suspend"
                  ></span>
                  <span v-else @click="play(1)" class="music-icon music-play"></span>

                  <span class="music-text">试听</span></span
                >
                <div class="music-item-btn">
                  <span v-if="hallInfo.musicBackground == 1" class="btn-selected"></span>
                  <span v-else @click="check(1)" class="btn-play "></span>
                </div>
              </div>
            </li>
            <li class="row-music-item">
              <div class="music-item-fr f-bd f-bd-btm">
                <div class="music-item-name"><div class="f-thide name">莫失莫忘</div></div>
                <span style="display: contents;">
                  <span
                    v-if="hallInfo.musicBackground == 2 && isPlaying"
                    @click="stop(2)"
                    class="music-icon music-suspend"
                  ></span>
                  <span v-else @click="play(2)" class="music-icon music-play"></span>
                  <span class="music-text">试听</span></span
                >
                <div class="music-item-btn">
                  <span v-if="hallInfo.musicBackground == 2" class="btn-selected"></span>
                  <span v-else @click="check(2)" class="btn-play "></span>
                </div>
              </div>
            </li>
            <li class="row-music-item">
              <div class="music-item-fr f-bd f-bd-btm">
                <div class="music-item-name"><div class="f-thide name">穿越时空的思念</div></div>
                <span style="display: contents;">
                  <span
                    v-if="hallInfo.musicBackground == 3 && isPlaying"
                    @click="stop(3)"
                    class="music-icon music-suspend"
                  ></span>
                  <span v-else @click="play(3)" class="music-icon music-play"></span>
                  <span class="music-text">试听</span></span
                >
                <div class="music-item-btn">
                  <span v-if="hallInfo.musicBackground == 3" class="btn-selected"></span>
                  <span v-else @click="check(3)" class="btn-play "></span>
                </div>
              </div>
            </li>
            <li class="row-music-item">
              <div class="music-item-fr f-bd f-bd-btm">
                <div class="music-item-name"><div class="f-thide name">天空之城</div></div>
                <span style="display: contents;">
                  <span
                    v-if="hallInfo.musicBackground == 4 && isPlaying"
                    @click="stop(4)"
                    class="music-icon music-suspend"
                  ></span>
                  <span v-else @click="play(4)" class="music-icon music-play"></span>
                  <span class="music-text">试听</span></span
                >
                <div class="music-item-btn">
                  <span v-if="hallInfo.musicBackground == 4" class="btn-selected"></span>
                  <span v-else @click="check(4)" class="btn-play "></span>
                </div>
              </div>
            </li>
            <li class="row-music-item">
              <div class="music-item-fr f-bd f-bd-btm">
                <div class="music-item-name"><div class="f-thide name">眼泪</div></div>
                <span style="display: contents;">
                  <span
                    v-if="hallInfo.musicBackground == 5 && isPlaying"
                    @click="stop(5)"
                    class="music-icon music-suspend"
                  ></span>
                  <span v-else @click="play(5)" class="music-icon music-play"></span>
                  <span class="music-text">试听</span></span
                >
                <div class="music-item-btn">
                  <span v-if="hallInfo.musicBackground == 5" class="btn-selected"></span>
                  <span v-else @click="check(5)" class="btn-play "></span>
                </div>
              </div>
            </li>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'set',
  data() {
    return {
      show: false,
      id: 1,
      isPlaying: false,
      checked: 1,
      hallInfo: {
        id: null,
        musicBackground: null,
      }
    }
  },
  methods: {
    play(id) {
      this.hallInfo.musicBackground = id
      let audio = this.$refs.audio1
      if (audio) {
        audio.play()
        this.isPlaying = true
        this.hallInfo.musicBackground = id
      }
    },
    stop(id) {
      this.hallInfo.musicBackground = id
      let audio = this.$refs.audio1
      if (audio) {
        audio.pause()
        this.isPlaying = false
      }
    },
    check(id) {
      this.hallInfo.musicBackground = id
      this.updateHallBackground()
    },
    goto(str) {
      this.$router.push({ path: str })
    },
    queryHallBackground(){
      var that = this
      this.$queryOne(
        'HallInfo',
        {id: this.id, myId: this.$store.getters.userId},
        this.hallInfo,
        function(res) {
          that.$fill(that.hallInfo, res.data)
        }
      )
    },
    updateHallBackground(){
      var that = this
      this.$submit('/api/hall/updateHallBackground', this.hallInfo, function(res) {
        if(res.code==1){
          that.queryHallBackground()
        }
      })
    }
  },
  mounted() {
    var params = this.$route.params
    this.id = Number(params['id'])
    let audio = this.$refs.audio1
    if (audio) {
      audio.pause()
      this.isPlaying = false
    }
    this.queryHallBackground()
  },
  created(){
  },
  watch: {},
}
</script>

<style>
.row-music-list {
  position: relative;
}

.music-selected {
  background: #dfa57e;
}

.row-music-item {
  padding: 0 1.363rem;
  position: relative;
  line-height: 3.3rem;
  box-sizing: border-box;
}

.row-music-item:after {
  content: '';
  border-top: 1px solid #f0f0f0;
  color: #f0f0f0;
  position: absolute;
  left: 1.363rem;
  right: 0;
  bottom: -2px;
  height: 1px;
  transform-origin: 0 0;
  transform: scaleY(0.5);
  z-index: 2;
}

.row-music-item .sgfl-cred {
  color: #df3436;
}

.row-music-item .selected-num {
  background: url(../../../assets/jnt/play1.png) no-repeat;
  background-size: 22px 22px;
  margin: 0 auto;
  background-position: 0;
}

.row-music-item .music-item-fr {
  display: -ms-flexbox;
  display: flex;
  position: relative;
  align-items: center;
}

.row-music-item .music-item-fr .music-icon {
  width: 18px;
  height: 18px;
}

.row-music-item .music-item-fr .music-play {
  background: url(../../../assets/jnt/play.png) no-repeat;
  background-size: 100% 100%;
}

.row-music-item .music-item-fr .music-suspend {
  background: url(../../../assets/jnt/stop1.png) no-repeat;
  background-size: 100% 100%;
}

.row-music-item .music-item-fr .music-text {
  margin-left: 5px;
  font-size: 1.18rem;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999;
}

.row-music-item .music-item-fr .music-badge {
  width: 6.18rem;
  position: absolute;
  right: 40px;
}

.row-music-item .music-item-fr .music-badge img {
  width: 100%;
}

.row-music-item .music-item-fr .music-author {
  width: 13.27rem;
  height: 3.45rem;
  line-height: 3.45rem;
  border-radius: 3.45rem;
  font-size: 2rem;
  transform: scale(0.5);
  transform-origin: right;
  text-align: center;
  background: linear-gradient(173deg, #fde0a6, #f4d491);
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #6e4e25;
  position: absolute;
  right: 40px;
}

.row-music-item .music-item-name {
  padding: 6px 0;
  min-width: 12rem;
  max-width: 12rem;
  text-align: left;
  margin-right: 1rem;
}

.row-music-item .music-item-name .name {
  font-size: 1.272rem;
  color: #333;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}

.row-music-item .music-item-btn {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  position: absolute;
  right: 0;
}

.row-music-item .music-item-btn .btn-play-pause {
  display: inline-block;
  width: 18px;
  height: 18px;
  background-position: -24px 0;
  box-sizing: border-box;
}

.row-music-item .music-item-btn .btn-play {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  border: 1px solid #999;
  box-sizing: border-box;
}

.row-music-item .music-item-btn .btn-play-disable {
  height: 18px;
  width: 18px;
  border-radius: 50%;
  border: 1px solid #dadada;
  box-sizing: border-box;
}

.row-music-item .music-item-btn .btn-pause {
  background: url(../../../assets/jnt/stop.png) no-repeat;
  background-size: 100%;
  height: 22px;
  width: 22px;
}

.row-music-item .music-item-btn .btn-selected {
  background: url(../../../assets/jnt/checked1.png) no-repeat;
  background-size: 100%;
  height: 18px;
  width: 18px;
  box-sizing: border-box;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.settingPage .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
</style>
